import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';

export class Loader {
    constructor(public status: boolean = false, public loaderName: string = '', public message?: string) {}
}

@Injectable()
export class LoaderService {

    // Observable string sources
    private loaderStatus = new Subject<Loader>();

    // Observable string streams
    loaderStatus$ = this.loaderStatus.asObservable();

    setStatus(loader: Loader) {
        console.log('event change loader status status', loader);
        this.loaderStatus.next(loader);
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/core/loader/loader.service.ts